import { useRouter } from 'next/router'
import { Col, Row, Grid, Tooltip, Whisper } from 'rsuite'
import { useSelector } from 'react-redux'
import { generalHelpers } from '@tweddle-se-team/common/helpers'
import DownloadButton from './downloadButton'
import useTranslation from '@/hooks/useTranslation'
import { ActionButton, PublicationButtons } from '../styles'
import { BsArrowRight, BsInfoSquare } from 'react-icons/bs'
import { AiOutlineDownload } from 'react-icons/ai'
import { generalConstants } from '@tweddle-se-team/common/constants'
import { productSelectors } from '@/store/products'
import { buildServiceWarrantyQuery } from '@/utils/publications/helpers'
import qs from 'qs'

const { UG, WTY } = generalConstants
const { contentTypes } = generalConstants

const { renamePubType, formatDate } = generalHelpers

const PublicationResultHeader = ({
  publicationTypes,
  publication,
  cached,
  publication: {
    publicationType,
    lineOffDate,
    year,
    partNumber,
    contents: { ditaId, highres, webview }
  },
  user,
  withPartNumber = true
}) => {
  const { brand } = useSelector(productSelectors.selectFilterBy)
  const t = useTranslation()
  const router = useRouter()
  const hasWebViewOrPDF = highres || webview
  const isLexus = brand.toLowerCase() === 'lexus'
  const displayLineOffDate = lineOffDate ? formatDate(lineOffDate) : lineOffDate
  const browseServiceWarranty = swFormat => {
    const query = buildServiceWarrantyQuery(router.query, year, swFormat)
    if (router.pathname === '/publications') {
      const { year: selectedYears } = qs.parse(router.query, { arrayLimit: 1000 })
      if (Array.isArray(selectedYears)) query.swReturnYears = selectedYears
    }

    router.push({
      pathname: '/serviceWarranty',
      query
    })
  }

  const browsePublication = () => {
    if (publicationType === WTY) return browseServiceWarranty(contentTypes.dita)
    router.push({ pathname: '/content', query: { id: ditaId, publicationType } })
  }

  return (
    <Grid fluid>
      <Row>
        <Col md={12} sm={12} xs={24}>
          <b style={{ fontSize: 16 }}>
            {t(renamePubType(publicationTypes, publicationType, 'label'), publicationType)}
          </b>
          {publicationType === UG && (
            <Whisper trigger="hover" placement="top" speaker={<Tooltip>{t('user_manual_hint')}</Tooltip>}>
              <span>
                <BsInfoSquare size={16} style={{ marginLeft: 5 }} />
              </span>
            </Whisper>
          )}
          {withPartNumber && (
            <>
              <br />
              <span className="medium">
                {t('finding_vehicle_publications_date')}:&nbsp;{displayLineOffDate}
                {publicationType !== WTY && (
                  <>
                    &nbsp;|&nbsp;{t('finding_vehicle_publications_part_no')}:&nbsp;{partNumber}
                  </>
                )}
              </span>
            </>
          )}
        </Col>
        <Col md={12} sm={12} xs={24}>
          <PublicationButtons>
            {publicationType !== WTY && hasWebViewOrPDF && !cached && (
              <DownloadButton publication={publication} user={user} />
            )}
            {publicationType === WTY && webview && !cached && (
              <ActionButton
                onClick={() => browseServiceWarranty(contentTypes.webview)}
                placement="right"
                appearance="ghost"
                $withIcon
                style={{ marginLeft: 10 }}
              >
                PDF <AiOutlineDownload size={16} className="fix-btn-icon" />
              </ActionButton>
            )}
            {ditaId && (
              <ActionButton
                $withIcon={isLexus}
                style={{ marginLeft: 10 }}
                onClick={browsePublication}
                appearance="primary"
              >
                {t('browse')} {isLexus && <BsArrowRight size={16} className="fix-btn-icon" />}
              </ActionButton>
            )}
          </PublicationButtons>
        </Col>
      </Row>
    </Grid>
  )
}

export default PublicationResultHeader
